import { Button, DetailIcon, Menu, MenuContent, MenuItem, MenuTrigger } from '@ds/components'

import type { TAudioAction } from '../../types/audioActionTypes'

import styles from './AudioActionsMenu.module.css'

type TAudioActionsMenuProps = {
    items: TAudioAction[]
    triggerLabel: string
}

/** Desktop more-actions menu of the hero bar. Empty list means the owner has nothing to do here. */
export const AudioActionsMenu = ({ items, triggerLabel }: TAudioActionsMenuProps) => {
    if (items.length === 0) {
        return null
    }

    return (
        <Menu modal={false}>
            <MenuTrigger asChild>
                <Button
                    variant="secondary"
                    size="medium"
                    LeftIcon={DetailIcon}
                    aria-label={triggerLabel}
                    data-test="more-button"
                />
            </MenuTrigger>
            <MenuContent>
                {items.map(({ id, label, Icon, onSelect, isDisabled }) => (
                    <MenuItem
                        key={id}
                        onSelect={onSelect}
                        disabled={isDisabled}
                        data-test={`audio-action-${id}`}
                    >
                        <span className={styles.item}>
                            <Icon className={styles.icon} />
                            <span>{label}</span>
                        </span>
                    </MenuItem>
                ))}
            </MenuContent>
        </Menu>
    )
}
